import { Box, Button } from '@chakra-ui/react';
import React from 'react';
import { getUsefulVars } from '../../../handlers/helpers';
import { previewEditButton } from '../utils';

const EditButton = ({props, buttonLabel, target, sectionIndex= 0}) => {
  const uv = getUsefulVars(props);
  let className = 'editButton';
  //tricky.
  if(target==='professional-experience') {
    // Do not mutate state during render; rely on the passed sectionIndex in the click handler
    className = className +' editButtonPE'
  }
  return (

    <Box className='editButtonDiv' >
      <Button className={className}
              onClick={() => previewEditButton(props,target,sectionIndex) }>
        {buttonLabel}
      </Button>
    </Box>
  );
};
export default EditButton;

//stateProps.onPreviewClose();